import React, { useState, useRef } from "react";
import Text from "../../../atoms/text/Text";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import EditableText, {
  Handles as EditableTextHandles,
} from "../../../atoms/text/EditableText";
import Clickable from "../../../atoms/clickable/Clickable";
import Icon from "../../../atoms/icon/Icon";

interface Props {
  layout: API.ReportingTemplateLayoutResponse;
  onUpdate: (
    layoutId: string,
    data: API.ReportingTemplateLayoutUpdateRequest,
  ) => void;
}

export const EditSpeakerNotes: React.FC<Props> = ({ layout, onUpdate }) => {
  const [editableTextKey, setEditableTextKey] = useState(layout.id);
  const editableTextRef = useRef<EditableTextHandles>(null);

  const handleChange = async (newValue: string) => {
    setEditableTextKey(editableTextKey + 1);
    onUpdate(layout.id, {
      speakerNotes: newValue,
    });
  };

  return (
    <InlineGroup verticalCenter spaceBetweenElements={2}>
      <InlineGroup>
        <Text>Speaker Notes:</Text>
      </InlineGroup>
      <InlineGroup spaceBetweenElements={2}>
        <EditableText
          key={editableTextKey}
          size="md"
          ref={editableTextRef}
          type="textbox"
          onChange={handleChange}
          value={layout.speakerNotes}
        />
        <Clickable onClick={() => editableTextRef.current?.setIsEditing(true)}>
          <Icon
            noMargin
            type="edit"
            tip={{ content: "Edit Speaker Notes", id: "edit-speaker-notes" }}
          />
        </Clickable>
      </InlineGroup>
    </InlineGroup>
  );
};
